// extracted by css-extract-rspack-plugin
export default {"actionButtons":"xJK4yud1Z4c4lUl3","controlLabel":"Gz4AGrxul3Qbtt9R","checkBoxItem":"tue3R1WuO4E4SYSF","radioItem":"PzYHUjbr4EANd1Nf","subTitle":"EamUyBJHQ6gHt5uO"};